import { utils, write } from 'xlsx';

import {
  createImportVisitorsTemplateExampleRow,
  createImportVisitorsTemplateHeaders,
} from '@/workers/import-visitors-worker/import-visitors-columns';

export const createVisitorsTemplateXlsxBlob = (allowInviteToParking: boolean) => {
  const headers = createImportVisitorsTemplateHeaders(allowInviteToParking);
  const exampleRow = createImportVisitorsTemplateExampleRow(allowInviteToParking);
  const worksheet = utils.aoa_to_sheet([Array.from(headers), Array.from(exampleRow)]);

  worksheet['!cols'] = headers.map(header => ({
    wch: Math.max(header.length + 2, 20),
  }));

  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, 'Visitors');

  const workbookBuffer = write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  return new Blob([workbookBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
};
